import cn from 'classnames';
import * as React from 'react';

import Text from '../text';
import useInputValidation from '../use-input-validation';

import { Toggle as Props } from './toggle.types';

const Toggle = React.forwardRef<
  HTMLInputElement,
  React.PropsWithChildren<Props>
>(
  (
    {
      children,
      isLabelVisible = true,
      label,
      labelPosition = 'right',
      name,
      value = '',
      spaceBetween,
      testId,
      ...rest
    },
    ref,
  ) => {
    const [onChange, onInvalid, error] = useInputValidation();

    return (
      <div
        className={cn('toggle', {
          'toggle--error': error,
        })}
      >
        <label
          className={cn('toggle__content', {
            'toggle__content--space-between': spaceBetween,
          })}
          data-testid={testId}
        >
          {isLabelVisible && labelPosition === 'left' && (
            <div className="toggle__label">
              <Text>{label}</Text>
              {children}
            </div>
          )}

          <div className="toggle__button-wrap">
            <input
              aria-label={isLabelVisible ? undefined : label}
              className="toggle__input"
              type="checkbox"
              name={name}
              onChange={e => {
                // NOTE: If props specify an `onChange`, we need to call that too
                if (rest.onChange) rest.onChange(e);
                onChange(e);
              }}
              onInvalid={e => {
                // NOTE: If props specify an `onInvalid`, we need to call that too
                if (rest.onInvalid) rest.onInvalid(e);
                onInvalid(e);
              }}
              ref={ref}
              value={value}
              {...rest}
            />
            <span className="toggle__slider">
              <div className="toggle__slider-element"></div>
            </span>
          </div>

          {isLabelVisible && labelPosition === 'right' && (
            <div className="toggle__label">
              <Text>{label}</Text>
              {children}
            </div>
          )}
        </label>
      </div>
    );
  },
);

export default Toggle;
